var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"warning","outlined":""},on:{"click":function($event){return _vm.$emit('remove', _vm.item)}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" $deleteItemForever ")]),_vm._v(" "+_vm._s(_vm.$t('base.delete'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }